module.exports = __webpack_public_path__ + "img/Flag_of_Ecuador.94317bef.svg";